import PropTypes from 'prop-types';
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
    Button,
    Card,
    CardBody,
    CardFooter,
    Col,
    Container,
    Row,
    UncontrolledTooltip,
} from "reactstrap";
import { size } from "lodash";
import Breadcrumbs from "../../../components/Common/Breadcrumb";


import Nouserimage from "../../../assets/images/users/no_image.png";
import Spinners from "components/Common/Spinner";
import UserService from 'Api/Services/UserService';



const AssignDrugList = () => {

    //meta title
    document.title = "Drug List | infuseone";
    const imageUrl = `${process.env.REACT_APP_DRUG_IMAGE_API_URL}`;
    const [isLoading, setLoading] = useState(false);
    const [userDrugList, setUsersDruglist] = useState([]);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [isListView, setIsListView] = useState(false);
    const navigate = useNavigate();

    const LoadUserAssignedDrugList = async () => {
        setLoading(true);
        try {
            const response = await UserService.GetUserAssignedDrugList().json();

            if (response.status === true) {
                setUsersDruglist(response.data);
                setLoading(false);
            } else {
                setLoading(false);
                setError(response.message);
                return;
            }
        } catch (error) {
            setError('Something went wrong');
            return;
        }
    };

    const handleAssigneUDrugs = async (drugId) => {
        navigate(`/assgined-user-drug-form/${drugId}`);
    };

    const toggleView = () => {
        setIsListView(!isListView);
    };
    useEffect(() => {
        LoadUserAssignedDrugList();
    }, []);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="container-fluid">
                        <Breadcrumbs title="Dashboard" breadcrumbItem="Drug List" />
                        {isLoading ? <Spinners setLoading={setLoading} /> :
                            <>
                                <Row >
                                    {error ?
                                        <div className='bg-white p-5 rounded'>
                                            <h5 className='text-center'>{error}</h5>
                                        </div>
                                        : ''
                                    }

                                    <div className='d-flex justify-content-end mb-2'>
                                        <span className='badge btn btn-primary font-size-15 m-1'>
                                            <i className='bx bx-list-ul font-size-20 mx-1' onClick={toggleView} style={{ cursor: 'pointer', color: isListView ? 'white' : 'black' }}></i>
                                            <i className='bx bx-grid-alt font-size-20 mx-1' onClick={toggleView} style={{ cursor: 'pointer', color: !isListView ? 'white' : 'black' }}></i>
                                        </span>
                                    </div>


                                    {isListView ? (
                                        <table className="table mt-3 commonboxform vertical-middle">
                                            <thead>
                                                <tr className='text-center'>
                                                    <th>Image</th>
                                                    <th>Title</th>
                                                    <th>Options</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {userDrugList.map((DrugList, index) => (
                                                    <tr key={index} className='text-center'>
                                                        <td>
                                                            <img className="imagedrugcls" src={`${imageUrl}/${DrugList.image}`} alt={DrugList.title} />
                                                        </td>
                                                        <td className=''>
                                                            <Link to="#" className="text-dark">{DrugList.title}</Link>
                                                        </td>
                                                        <td>
                                                            <a className="btn btn-secondary font-size-14 m-1" onClick={() => handleAssigneUDrugs(DrugList.drug_id)}>
                                                                Fill Form
                                                            </a>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    ) : (
                                        userDrugList.map((DrugList, index) => (
                                            <Col xl={3} sm={6} key={index}>
                                                <Card className="text-center boxcardcls ">
                                                    <CardBody>
                                                        <div className="mb-3 imgwarp">
                                                            <img className="imagedrugcls" src={`${imageUrl}/${DrugList.image}`} alt={DrugList.title} />
                                                        </div>
                                                        <div>
                                                            <h5 className="font-size-15 mb-1">
                                                                <Link to="#" className="text-dark">{DrugList.title}</Link>
                                                            </h5>
                                                            <div className='mt-2'>
                                                                {/* class badge */}
                                                                <a className="btn btn-secondary font-size-14 m-1" onClick={() => handleAssigneUDrugs(DrugList.drug_id)}>
                                                                    Fill Form
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        ))
                                    )}
                                </Row>

                            </>
                        }
                    </div>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default AssignDrugList;